import { Component, OnInit,TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_PM_Program_Interface, PM_Program_Interface } from 'src/app/Interface/PM_Program_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PM_ProgramService } from 'src/app/Service/PM/PM_Program.service';

@Component({
  selector: 'app-PMProgramList',
  templateUrl: './PMProgramList.component.html',
  styleUrls: ['./PMProgramList.component.css']
})
export class PMProgramListComponent implements OnInit {
  Filter_Title: string = ""

  page: number = 0;
  Procssing: boolean = false

  modalRef_Delete: any;

  constructor(
    private PM_Program_Service: PM_ProgramService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    public router: Router,
    private modalService: BsModalService
  ) { }


  DataList_PM: Array<PM_Program_Interface> = []
  Data_Seleted_Delete: PM_Program_Interface = Empty_PM_Program_Interface()

  ngOnInit() {

    this.Nav_Service.CheckValidPage(1159).subscribe(
      data => {
        this.ReadData_PM()
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_PM() {
    this.Procssing = true
    this.PM_Program_Service.GetRecord().subscribe(
      data => {
        this.DataList_PM = data
        this.Procssing = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }



  Change_Filter() {
    this.page = 0
  }

  Delete(item: PM_Program_Interface) {

    this.modalRef_Delete.hide()
    this.PM_Program_Service.DeletePM(item.id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("اعمال شد")
        this.ReadData_PM()
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  openModal(template: TemplateRef<any>, Record) {
    this.Data_Seleted_Delete = Record
    this.modalRef_Delete = this.modalService.show(template);
  }


  //#region PM Form

  Selected_PM_Record: PM_Program_Interface
  Selected_PM_Record_Switcher: string = 'List'
  Set_List_PM_View() {
    this.Selected_PM_Record_Switcher= 'List'
  }

  Set_Form_PM_View(item:PM_Program_Interface,Switcher:string) {
    this.Selected_PM_Record = item
    this.Selected_PM_Record_Switcher= Switcher
  }

  Set_Form_PM_View_Add() {
    this.Selected_PM_Record = Empty_PM_Program_Interface()
    this.Selected_PM_Record_Switcher= 'Form'
  }

  //#endregion

}

